import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

const KEY = "sn_age_verified";
export const AGE_RESTRICTED_CATEGORIES = ["cigars"];

export function isAgeVerified() {
  return localStorage.getItem(KEY) === "yes";
}

export function AgeGate({ onVerified }) {
  const navigate = useNavigate();
  const confirm = () => {
    localStorage.setItem(KEY, "yes");
    onVerified && onVerified();
  };
  return (
    <div className="fixed inset-0 z-[70] grid place-items-center bg-ink/90 backdrop-blur-md px-4" data-testid="age-gate">
      <div className="max-w-md w-full bg-white rounded-3xl border border-border p-8 text-center sn-fade-up">
        <span className="mx-auto h-14 w-14 grid place-items-center rounded-2xl bg-coral/10 text-coral mb-4">
          <ShieldAlert size={28} />
        </span>
        <h2 className="font-clash font-bold text-2xl tracking-tight">Age-Restricted Section</h2>
        <p className="text-muted-foreground text-sm mt-3">
          This section contains tobacco products. You must be <strong className="text-ink">18 years or older</strong> —
          the legal age in Jamaica — to view and purchase these items. Please confirm your age to continue.
        </p>
        <div className="flex flex-col gap-2 mt-6">
          <button data-testid="age-confirm-btn" onClick={confirm}
            className="w-full bg-emerald text-white rounded-full py-3 font-semibold hover:bg-emerald-deep transition-colors">
            I am 18 or older
          </button>
          <button data-testid="age-decline-btn" onClick={() => navigate("/")}
            className="w-full border border-border rounded-full py-3 font-semibold hover:bg-secondary transition-colors">
            I am under 18 — Exit
          </button>
        </div>
        <p className="text-[11px] text-muted-foreground mt-4">
          Tobacco use is harmful to health. Sale to minors is strictly prohibited by law.
        </p>
      </div>
    </div>
  );
}

export function ComplianceNotice({ text }) {
  return (
    <div data-testid="compliance-notice"
      className="rounded-2xl border border-coral/30 bg-coral/5 text-coral px-4 py-3 text-sm flex items-start gap-2 mb-6">
      <ShieldAlert size={18} className="mt-0.5 shrink-0" />
      <span>{text}</span>
    </div>
  );
}
